__turbopack_context__.v({
  "bgImageContainer": "ogdb-client-module__zPejkW__bgImageContainer",
});
